import { render, staticRenderFns } from "./ryzs.vue?vue&type=template&id=2e77d936&scoped=true&"
import script from "./ryzs.vue?vue&type=script&lang=js&"
export * from "./ryzs.vue?vue&type=script&lang=js&"
import style0 from "./ryzs.vue?vue&type=style&index=0&id=2e77d936&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e77d936",
  null
  
)

export default component.exports